import isFilledPopup from './isFilledPopup';
import isRequestSignaturePopup from './isRequestSignaturePopup';

export default popup => isRequestSignaturePopup(popup) && !isFilledPopup(popup);




// WEBPACK FOOTER //
// ./src-react/Popups/helpers/needsSignature.jsx